import React, { useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import "./UserProfile.css";
import { formatDate, capitalizeFirstLetter } from "../../utils/utils.js";

const UserProfile = ({
  isShown,
  onClose,
  handleSignOut,
  buttonViewMode,
  setButtonViewMode,
}) => {
  const currentUser = useContext(CurrentUserContext) || {};
  const { name, login, subscription = {} } = currentUser;
  const end = Array.isArray(subscription.end) ? subscription.end : [];
  const displayName = name || login || "user";
  const subscriptionEnd = end.length ? formatDate(end[end.length - 1]) : "";


  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleViewModeChange = (mode) => {
    setButtonViewMode(mode);
  };

  return (
    <div
      className={`user-profile ${isShown ? "user-profile_visible" : ""}`}
      onClick={handleBackdropClick}
    >
      <div className="user-profile__bio">
        <div className="user-profile__name">
          Welcome Back, {capitalizeFirstLetter(displayName)}
        </div>
        <span className="user-profile__login">
          Thank you for subscribing to AE2.
        </span>
      </div>
      {subscriptionEnd && (
        <div className="user-profile__subscription">
          Access to {subscriptionEnd}
        </div>
      )}
      <div className="user-profile__settings">
        <div className="user-profile__settings-title">Button Layout</div>
        <div className="user-profile__segmented-control">
          <button
            type="button"
            className={`user-profile__segmented-button ${
              buttonViewMode !== "grid"
                ? "user-profile__segmented-button_active"
                : ""
            }`}
            onClick={() => handleViewModeChange("list")}
          >
            List
          </button>
          <button
            type="button"
            className={`user-profile__segmented-button ${
              buttonViewMode === "grid"
                ? "user-profile__segmented-button_active"
                : ""
            }`}
            onClick={() => handleViewModeChange("grid")}
          >
            Grid
          </button>
        </div>
      </div>
      <span className="user-profile__login">
      </span>
      <div className="user-profile__logout" onClick={handleSignOut}>
        Sign Out
      </div>
    </div>
  );
};

export default UserProfile;
